/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function ChevronLeftIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path d="M13.468 19.406 25.456 7.47c.562-.625 1.498-.625 2.123 0 .561.562.561 1.5 0 2.062L16.59 20.47l10.926 11a1.37 1.37 0 0 1 0 2.062 1.366 1.366 0 0 1-2.06 0l-11.988-12c-.624-.562-.624-1.5 0-2.125"/>}
        </IconWrapper>);
}
